<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to>
        <img
          @click="$router.back(-1)"
          class="backPic"
          src="../../static/images/back.png"
        />
      </router-link>
      <div class="detailTitle">2020爱分析知识图谱厂商报告|北斗院榜上有名</div>
      <div class="detailTitleSecond">深圳北斗应用技术研究院 8月11日</div>
      <div class="line"></div>
      <div class="detailPic">
        <img src="../../static/images/newsDetailPic2.png" />
        <img
          class="secondTextPic"
          src="../../static/images/newsDetailPic1.png"
        />
      </div>
      <div class="detailTitleText">
        近日，专注科技创新领域的研究机构爱分析发布了《2020年爱分析知识图谱厂商分析报告》，北斗院凭借在知识图谱领域中的不断创新与深耕，在此次报告中榜上有名，聚焦在政府与公共服务领域的六大应用场景。
      </div>
      <div class="detailTitleLittle">知识图谱优化数据处理</div>
      <div class="detailTitleText">
        何为知识图谱？知识图谱是一种能够从海量非结构化数据中抽取结构化知识，并利用图分析进行关联关系挖掘的重要技术手段，是能够整合大数据并加以利用、洞察“肉眼”无法发现的关系和逻辑，支撑最终业务决策的技术。所有涉及到大量数据且需要挖掘关系的业务场景均可以利用知识图谱，知识图谱正在各行业进行持续的渗透，尤其是在智慧城市的建设中，知识图谱将起到重要支撑作用。在爱分析报告里，北斗院上榜政府与公共服务领域的智能刑侦、智能反恐、治安管理、智慧交通、应急管理、电子政务六大应用场景。
      </div>
      <div class="detailTitleLittle">北斗院助力智慧城市建设</div>
      <div class="detailTitleText">
        作为全局知识库，知识图谱可以将城市生活数据和城市管理数据进行关联分析与挖掘，赋能智慧城市各方面，让城市更加“聪明”。北斗院致力打造大交通行业的智能决策引擎，通过利用大数据、人工智能等技术，贯通交通组织感知-认知-决策-反馈的自适应闭环，助推智能化升级，实现安全、高效、可持续发展。报告中的政府与公共服务领域被划分为公安、交通、应急管理部、政务数字化四大模块，北斗院都有与之对应的落地产品并取得了优秀的成绩。
      </div>

      <div class="detailTitleLittle">公安</div>
      <div class="detailTitleText">
        公安行业前端数据强后端数据弱，导致公安数据庞大且复杂，办案人员需要从海量数据中快速抽取，发现有用信息，针对此类问题，北斗院的【智慧公安】产品-天枢公共交通智慧安全立体防控平台立足于服务公安实战，通过深化大数据、人工智能、物联网等前沿科技创新应用，搭建客流引擎、轨迹引擎、公共交通多维时空档案，构建以公共安全管控决策引擎为核心的智慧安全立体防控平台，建成集指挥调度、情报研判、立体防控、警务管理等为一体主动安全管理闭环，实现“情-指-勤-行”的一体化融合，致力于让公共交通更安全。2019年北斗天枢辅助抓获网逃嫌疑人2100余人，寻回走失老人和小孩200余人。
      </div>

      <div class="detailTitleLittle">交通</div>
      <div class="detailTitleText">
        日常出行中，面对城市交通拥堵不堪、各种突发情况导致道路无法通行等交通问题，北斗院【公共交通一体化智慧监测系统】基于城市TOCC综合管理需求，全面汇集城市级海量交通数据资源，结合交通大数据平台及算法模型，对多元时空数据进行融合、处理、分析，形成集交通基础数据资源管理、城市交通运行监测及预警、动态数据分析及决策辅助、综合行业监管四大板块为一体的智慧交通整体解决方案，实现从感知、分析、研判、到决策支撑的闭环业务。
      </div>

      <div class="detailTitleLittle">应急管理部门</div>
      <div class="detailTitleText">
        基于城市各种突发公共事件发生的频率越来越高、规模越来越大的现状，北斗院【城市公交应急指挥管理平台】建设了集中指挥、统一调度、联合行动、分头处置为一体的城市公交应急指挥管理平台，完善风险监测体系，建立科学决策处置机制，形成畅通有效的协同联动机制，打造应急处置的“最强大脑”。2018年国庆期间对大鹏、宝安机场、海上世界进行公交保障，共协同调度指挥39辆保障车辆、3个保障区域、3个保障站点、7个保障任务，累计发车班次120余次，疏散4000多人次客流。
      </div>

      <div class="detailTitleLittle">政务管理系统</div>
      <div class="detailTitleText">
        当前各级政府部门已经形成了海量数据资源池，但面临着服务于业务数据的应用较少、处理困难的问题，北斗院的【城市运行管理平台】为城市精细化科学化管理提供技术和决策支持，提高城市整体运行效率、社会治理能力、城市综合水平管理。2019年，北斗院国家重点专项“互联网+政务大数据透明管理与智能服务平台”获批，助力智慧城市建设再上新台阶。
      </div>

      <div class="detailTitleLittle">知识图谱的广泛应用</div>
      <div class="detailTitleText">
        知识图谱的应用范围大而深，数字经济浪潮的席卷下，利用新兴技术赋能企业数字化转型已是大势所趋。除去被提及的四大产品，北斗院还有【智慧物流】、【智慧机场】、【智慧园区】等产品。知识图谱将不同知识之间进行关联，形成网状知识结构，其本质是在构建行业或领域内的知识，将知识赋予给机器，在实际业务环节中运用，从而产生更大的价值。此次上榜2020年爱分析知识图谱厂商分析报告，既是对北斗院知识图谱成果的肯定，也将激励北斗院继续前进，聚焦利用云计算、大数据、人工智能等先进技术为各行各业提供安全、可靠、高效的服务。
      </div>
      <div class="newsDetailFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>

<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {},
};
</script>
<style scoped>
@import "./NewsDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/NewsDetail.vue